var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome2020 = function SvgHome2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0E1",
    d: "m10 1.204-.498.475L.5 10.682l.996.996.887-.889v8.008h6.232v-6.925h2.77v6.925h6.232V10.79l.887.887.996-.995-9.002-9.003zm0 1.969 6.232 6.232v8.007H12.77v-6.925H7.23v6.925H3.768V9.405z"
  })));
};
export default SvgHome2020;